import { Component, Input, OnInit } from '@angular/core'
import { GeneralService } from 'src/app/services/general/general.service'
import { LogService } from 'src/app/services/log/log.service'

@Component({
  selector: 'app-coupang-ad',
  templateUrl: './coupang-ad.component.html',
  styleUrls: ['./coupang-ad.component.scss'],
})
export class CoupangAdComponent implements OnInit {
  constructor(private logService: LogService, private generalService: GeneralService) {}

  @Input() adType: 'small' | 'big' = 'small'
  @Input() style: string = ''
  @Input() logParams: Record<string, string | number | undefined> | undefined
  showCoupangAd = this.generalService.showCoupangAd
  private showCoupangAdSubscription = this.generalService.getShowCoupangAdSubject().subscribe((showCoupangAd) => {
    this.showCoupangAd = showCoupangAd
  })

  ngOnInit() {
    window.addEventListener('message', (event) => {
      if (event?.data?.type === 'adClicked') {
        this.onClickBanner()
      }
    })
  }

  ngOnDestroy() {
    window.removeEventListener('message', () => {})
    this.showCoupangAdSubscription.unsubscribe()
  }

  onClickBanner(): void {
    this.logService.ad.adBannerClicked({ ...this.logParams, type: 'unblocked' })
  }
}
